import React from 'react';

import {CallMade} from '@material-ui/icons';
import {AppBar, Box, Grid} from '@material-ui/core';

import {useSpinner} from 'hooks';
import {useSnackbar} from 'notistack';
import {KeycloakService} from 'services';
import {EfeResponse} from 'commons/models';
import {EfeButtonPrimary} from 'components';
import {AppBarStyles} from 'assets/tss/commons';
import {
    AnalyticsCategories,
    HistoryRoutes,
    Messages,
    SnackbarVariants,
    USER_DATA,
} from 'commons/constants';
import {useHistory} from 'react-router-dom';
import {useMenuContext} from 'context/onboarding-menu/OnboardingMenu';
import {useRelatedPeopleContext} from 'context/related-people-flow/RelatedPeopleFlow';
import {useUserContext} from 'context/user/UserContext';
import {functions, messageFunctions} from 'commons/utils';
import {useAnalytics} from 'hooks/AnalyticsHook';
import {useBeneficiaryContext} from 'context/beneficiary-context/BeneficiaryContext';

function Topbar() {
    const history = useHistory();
    const classes = AppBarStyles();
    const {sendEvent} = useAnalytics();
    const {resetRelatedPeopleContext} = useRelatedPeopleContext();
    const {resetBeneficiaryContext} = useBeneficiaryContext();
    const {enqueueSnackbar} = useSnackbar();
    const {resetMenuProvider} = useMenuContext();
    const {resetUserProvider} = useUserContext();
    const [isLoading, setIsLoading] = React.useState<boolean>(false);

    async function handleSubmit(): Promise<string> {
        setIsLoading(true);
        try {
            sendEvent(
                AnalyticsCategories.LOGOUT,
                messageFunctions.getAnalyticsMessage(
                    `${AnalyticsCategories.LOGOUT} for user`,
                    USER_DATA.username.toUpperCase()
                )
            );
            USER_DATA.loggedIn = false;
            USER_DATA.logout = false;
            const logout: EfeResponse<number> = await KeycloakService.logout(USER_DATA);
            if (!logout || !logout.data) {
                enqueueSnackbar(Messages.LOGOUT_ERROR, {
                    variant: SnackbarVariants.ERROR,
                });
            }
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
            console.error(error);
            enqueueSnackbar(Messages.LOGOUT_ERROR, {
                variant: SnackbarVariants.ERROR,
            });
        }
        resetMenuProvider();
        resetUserProvider();
        resetRelatedPeopleContext();
        resetBeneficiaryContext();
        functions.resetUserDataConstant();
        history.push(HistoryRoutes.LOGIN);
        return 'logout';
    }

    const alertUser = (event: any) => {
        event.preventDefault();
        event.returnValue = false;
    };

    const unloadPage = async (event: any) => {
        event.preventDefault();
    };

    React.useEffect(() => {
        window.addEventListener('beforeunload', alertUser);
        window.addEventListener('unload', unloadPage);
        return () => {
            window.removeEventListener('beforeunload', alertUser);
            window.removeEventListener('unload', unloadPage);
        };
    });

    React.useEffect(() => {
        if (USER_DATA.logout) {
            handleSubmit();
        }
    }, [USER_DATA.logout, USER_DATA.loggedIn]);

    return (
        <AppBar position='fixed' color='primary' className={classes.topBar}>
            {isLoading && useSpinner(isLoading)}
            <Grid container direction='row' justifyContent='flex-end'>
                <Box m={2}>
                    <EfeButtonPrimary
                        onClick={handleSubmit}
                        type='submit'
                        disabled={false}
                        endIcon={<CallMade />}>
                        {'Cerrar sesi\u00F3n'}
                    </EfeButtonPrimary>
                </Box>
            </Grid>
        </AppBar>
    );
}

export default Topbar;
